// 添加广告节点
const insert_adv = (para) => {
    let js_Parent = document.getElementById(para).childNodes[0];
    if (js_Parent.querySelector('script')) {
        let js_adv = js_Parent.childNodes[0];
        let adv_node = document.createElement("script");
        adv_node.type = 'text/javascript';
        adv_node.innerHTML = js_adv.innerHTML;
        js_Parent.appendChild(adv_node);
        js_Parent.removeChild(adv_node);
    }

};

// 添加脚本执行完 移除广告脚本
const remove_adv = (para) => {
    let js_Parent = document.getElementById(para).childNodes[0];
    if (js_Parent.querySelector('script')) {
        let target = js_Parent.parentNode.childNodes[0];
        js_Parent.parentNode.removeChild(target);
    }
};

export { insert_adv, remove_adv };